import { set } from "lodash";
import { TIntegracaoCampoModel } from "../../../../@types/IntegracaoCampoModel";
import useDisplayRule from "../useDisplayRule/useDisplayRule";
import usePayloadResolver from "../usePayloadResolver/usePayloadResolver";

export type TBuildLegacyPayloadParams = {
  apiHash: string | number;
  fields: TIntegracaoCampoModel[];
  values: Record<string, unknown>;
  webserviceId?: string | null;
  inativo?: boolean | null;
};

export default function useBuildLegacyPayload() {
  const { valueMatchesDisplayRule } = useDisplayRule();
  const { resolvePayloadNode } = usePayloadResolver();

  const buildLegacyPayload = ({
    apiHash,
    fields,
    values,
    webserviceId = null,
    inativo = null
  }: TBuildLegacyPayloadParams): Record<string, unknown> => {
    const payload: Record<string, unknown> = {
      _id: webserviceId,
      API: String(apiHash),
      Inativo: inativo
    };

    fields.forEach((field) => {
      if (field.includeInPayload === false) return;

      const path = field.nomeObjetoNoLegado?.trim();
      if (!path) return;
      if (
        field.regraExibicao &&
        !valueMatchesDisplayRule(field.regraExibicao, values)
      )
        return;

      const value = field.payloadTransform
        ? resolvePayloadNode(
            {
              CampoId: field.nomeCampo,
              Transform: field.payloadTransform
            },
            values
          )
        : values[field.nomeCampo];

      const isStoneOrTecnofit =
        Number(apiHash) === 10 || Number(apiHash) === 282;
      const legacyValue =
        isStoneOrTecnofit && path === "Empresa"
          ? (() => {
              const selectedValue = Array.isArray(value) ? value[0] : value;
              if (
                selectedValue !== null &&
                typeof selectedValue === "object"
              ) {
                const selectedRecord = selectedValue as Record<string, unknown>;

                return (
                  selectedRecord._id ?? selectedRecord.id ?? selectedRecord.value
                );
              }

              return selectedValue;
            })()
          : value;

      set(payload, path, legacyValue);
    });

    return payload;
  };

  return { buildLegacyPayload };
}
